var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    fill: "none",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2.6,
    d: "M37.938 14.072v20.24a3.374 3.374 0 0 1-3.374 3.376H10.437a3.374 3.374 0 0 1-3.374-3.376v-20.24m34 0v-4.51a2.25 2.25 0 0 0-2.25-2.25H6.188a2.25 2.25 0 0 0-2.25 2.25v4.51h37.125ZM18.375 25.883h8.25c1.14 0 2.063-1.037 2.063-2.317 0-1.28-.924-2.317-2.063-2.317h-8.25c-1.139 0-2.062 1.037-2.062 2.317 0 1.28.923 2.317 2.062 2.317Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPast);
export default __webpack_public_path__ + "static/media/past.0d5c787f4624281c59a153059c4900c4.svg";
export { ForwardRef as ReactComponent };